/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rate_Limit_Error_MessageInputs */

const en_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate limit hit. Please wait a few moments and try again.`)
};

const id_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate limit tercapai. Tunggu beberapa saat dan coba lagi.`)
};

const ms_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Had kadar sudah dicapai. Sila tunggu beberapa saat dan cuba lagi.`)
};

const ca_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'ha assolit el límit de taxa. Espera uns moments i torna-ho a intentar.`)
};

const cs_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bylo dosaženo limitu rychlosti. Počkejte prosím chvíli a zkuste to znovu.`)
};

const da_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beløbsgrænsen er nået. Vent et øjeblik, og prøv igen.`)
};

const de_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Limit wurde erreicht. Warte bitte kurz und versuch's nochmal.`)
};

const et_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülemmäär on saavutatud. Palun oodake mõni hetk ja proovige uuesti.`)
};

const es_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcanzaste el límite de tasas. Espera unos momentos y vuelve a intentarlo.`)
};

const fr_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite de taux atteinte. Veuillez patienter quelques instants et réessayer.`)
};

const hr_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostigli ste limit. Pričekajte nekoliko trenutaka i pokušajte ponovno.`)
};

const it_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raggiunto il limite di traffico. Aspetta qualche secondo e riprova.`)
};

const lv_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sasniegts pieprasījumu limits. Lūdzu, uzgaidiet dažus mirkļus un mēģiniet vēlreiz.`)
};

const lt_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasiektas užklausų limitas. Šiek tiek palaukite ir bandykite dar kartą.`)
};

const hu_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elérte a kérések megengedett korlátját. Kérjük, várjon néhány pillanatot, majd próbálja meg újra.`)
};

const nl_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limiet bereikt. Wacht even en probeer het opnieuw.`)
};

const nb_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grensen ble nådd. Vent litt og prøv på nytt.`)
};

const pl_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięto limit zapytań. Poczekaj chwilę i spróbuj ponownie.`)
};

const pt_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite de taxa atingido. Aguarde alguns instantes e tente novamente.`)
};

const ro_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rata limită a fost atinsă. Te rugăm să aştepţi câteva momente şi să încerci din nou.`)
};

const sk_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bol dosiahnutý limit. Počkajte prosím chvíľu a skúste to znova.`)
};

const sl_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omejitev zahtevkov je dosežena. Počakajte nekaj trenutkov in poskusite znova.`)
};

const fi_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käyttöraja on ylitetty. Odota hetki ja yritä uudelleen.`)
};

const sv_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beloppsgränsen är nådd. Vänta en stund och försök igen.`)
};

const vi_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đạt giới hạn. Vui lòng chờ một lát và thử lại.`)
};

const tr_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım sıklığı sınırına ulaşıldı. Lütfen birkaç dakika bekleyin ve tekrar deneyin.`)
};

const el_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φτάσατε το όριο. Περιμένετε λίγα λεπτά και προσπαθήστε ξανά.`)
};

const bg_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лимитът е достигнат. Моля, изчакай няколко минути и опитай отново.`)
};

const ru_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Превышен лимит запросов. Пожалуйста, подождите несколько секунд и попробуйте снова.`)
};

const sr_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достигли сте ограничење. Сачекајте и пробајте поново.`)
};

const uk_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вичерпано ліміт швидкості. Будь ласка, зачекайте кілька хвилин і спробуйте ще раз.`)
};

const ka_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ლიმიტის ზღვარი მიღწეულია. გთხოვთ, დაელოდოთ რამდენიმე წუთი და ხელახლა სცადოთ.`)
};

const hi_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेट लिमिट हिट। कृपया थोड़े समय बाद दोबारा कोशिश करें। `)
};

const th_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถึงขีดจำกัดการใช้บริการ รอสักครู่แล้วลองใหม่อีกครั้ง`)
};

const ko_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요청 한도에 도달했습니다. 잠시 기다렸다가 다시 시도해 주세요.`)
};

const zh_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已达到速率限制。请稍等片刻再试。`)
};

const zh_tw_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已達到速率限制。請稍候片刻後再試一次。`)
};

const ja_rate_limit_error_message = /** @type {(inputs: Rate_Limit_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レート制限に達しました。しばらく待ってからもう一度お試しください。`)
};

/**
* | output |
* | --- |
* | "Rate limit hit. Please wait a few moments and try again." |
*
* @param {Rate_Limit_Error_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const rate_limit_error_message = /** @type {((inputs?: Rate_Limit_Error_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rate_Limit_Error_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rate_limit_error_message(inputs)
	if (locale === "ms") return ms_rate_limit_error_message(inputs)
	if (locale === "ca") return ca_rate_limit_error_message(inputs)
	if (locale === "cs") return cs_rate_limit_error_message(inputs)
	if (locale === "da") return da_rate_limit_error_message(inputs)
	if (locale === "de") return de_rate_limit_error_message(inputs)
	if (locale === "et") return et_rate_limit_error_message(inputs)
	if (locale === "es") return es_rate_limit_error_message(inputs)
	if (locale === "fr") return fr_rate_limit_error_message(inputs)
	if (locale === "hr") return hr_rate_limit_error_message(inputs)
	if (locale === "it") return it_rate_limit_error_message(inputs)
	if (locale === "lv") return lv_rate_limit_error_message(inputs)
	if (locale === "lt") return lt_rate_limit_error_message(inputs)
	if (locale === "hu") return hu_rate_limit_error_message(inputs)
	if (locale === "nl") return nl_rate_limit_error_message(inputs)
	if (locale === "nb") return nb_rate_limit_error_message(inputs)
	if (locale === "pl") return pl_rate_limit_error_message(inputs)
	if (locale === "pt") return pt_rate_limit_error_message(inputs)
	if (locale === "ro") return ro_rate_limit_error_message(inputs)
	if (locale === "sk") return sk_rate_limit_error_message(inputs)
	if (locale === "sl") return sl_rate_limit_error_message(inputs)
	if (locale === "fi") return fi_rate_limit_error_message(inputs)
	if (locale === "sv") return sv_rate_limit_error_message(inputs)
	if (locale === "vi") return vi_rate_limit_error_message(inputs)
	if (locale === "tr") return tr_rate_limit_error_message(inputs)
	if (locale === "el") return el_rate_limit_error_message(inputs)
	if (locale === "bg") return bg_rate_limit_error_message(inputs)
	if (locale === "ru") return ru_rate_limit_error_message(inputs)
	if (locale === "sr") return sr_rate_limit_error_message(inputs)
	if (locale === "uk") return uk_rate_limit_error_message(inputs)
	if (locale === "ka") return ka_rate_limit_error_message(inputs)
	if (locale === "hi") return hi_rate_limit_error_message(inputs)
	if (locale === "th") return th_rate_limit_error_message(inputs)
	if (locale === "ko") return ko_rate_limit_error_message(inputs)
	if (locale === "zh") return zh_rate_limit_error_message(inputs)
	if (locale === "zh-tw") return zh_tw_rate_limit_error_message(inputs)
	if (locale === "ja") return ja_rate_limit_error_message(inputs)
	return en_rate_limit_error_message(inputs)
});